const { DEVICE_TYPE } = require('../../../../constants/commons');
const { LocalPickup } = require('./LocalPickup');
const { ShippingActions } = require('./ShippingActions');

const ShippingReview = ({
  options,
  deviceType,
  rebranding,
  changeShippingOption,
  changeShippingAddress,
}) => {
  const isMobile = DEVICE_TYPE.MOBILE === deviceType;
  return (
    <section className="shipping-generics shipping-review">
      {options?.is_pickup ? (
        <LocalPickup
          isMobile={isMobile}
          rebranding={rebranding}
          handleShippingOptions={changeShippingOption}
        />
      ) : (
        <ShippingActions
          isMobile={isMobile}
          rebranding={rebranding}
          delivery={options.delivery}
          handleShippingOptions={changeShippingOption}
          handleShippingAddress={changeShippingAddress}
        />
      )}
    </section>
  );
};

module.exports = { ShippingReview };
